// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dRouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $DineInLocation = (tag, _1) => ({tag, _1});
const numberIsSymbol = {reflectSymbol: () => "number"};
const TableIsSymbol = {reflectSymbol: () => "Table"};
const areaIdIsSymbol = {reflectSymbol: () => "areaId"};
const areaNameIsSymbol = {reflectSymbol: () => "areaName"};
const pointNameIsSymbol = {reflectSymbol: () => "pointName"};
const ServingLocationIsSymbol = {reflectSymbol: () => "ServingLocation"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const Table = value0 => $DineInLocation("Table", value0);
const ServingLocation = value0 => $DineInLocation("ServingLocation", value0);
const toFillFormTypeDineInLocat = {fillFormDataType: v => "unknown"};
const eqDineInLocation = {
  eq: x => y => {
    if (x.tag === "Table") {
      if (y.tag === "Table") { return x._1.number === y._1.number; }
      return false;
    }
    if (x.tag === "ServingLocation") {
      if (y.tag === "ServingLocation") { return x._1.areaId === y._1.areaId && x._1.areaName === y._1.areaName && x._1.pointName === y._1.pointName; }
      return false;
    }
    return false;
  }
};
const genericDineInLocation = {
  to: x => {
    if (x.tag === "Inl") { return $DineInLocation("Table", x._1); }
    if (x.tag === "Inr") { return $DineInLocation("ServingLocation", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Table") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ServingLocation") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showDineInLocation = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ number: " + Data$dShow.showIntImpl(v.number) + " }"]})(TableIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ areaId: " + Data$dShow.showIntImpl(v.areaId) + ", areaName: " + Data$dShow.showStringImpl(v.areaName) + ", pointName: " + Data$dShow.showStringImpl(v.pointName) + " " + "}"
      ]
    })(ServingLocationIsSymbol);
    return x => {
      if (x.tag === "Table") { return $0["genericShow'"](x._1); }
      if (x.tag === "ServingLocation") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeDineInLocation = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble$dGeneric.genericUnsafeDecodeTagged(genericDineInLocation)(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(TableIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(numberIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(ServingLocationIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(areaIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(areaNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(pointNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    })))(Unscramble$dGeneric.defaultOptions)
  }
))();
const encodingOptsDineInLocation = {...Foreign$dGeneric$dClass.defaultOptions, unwrapSingleConstructors: true, unwrapSingleRecordArguments: true};
const encodeDineInLocation = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(TableIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(numberIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(ServingLocationIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(pointNameIsSymbol)(encodeWithOptionsOther))(areaNameIsSymbol)(encodeWithOptionsOther))(areaIdIsSymbol)({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return x => {
      if (x.tag === "Table") { return $0.encodeOpts({...encodingOptsDineInLocation, unwrapSingleConstructors: false})(x._1); }
      if (x.tag === "ServingLocation") { return $1.encodeOpts({...encodingOptsDineInLocation, unwrapSingleConstructors: false})(x._1); }
      $runtime.fail();
    };
  })()
};
const decodeDineInLocation = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericDineInLocation)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(TableIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(numberIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ServingLocationIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(pointNameIsSymbol)(decodeWithOptionsOther)())(areaNameIsSymbol)(decodeWithOptionsOther)())(areaIdIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument)))({...encodingOptsDineInLocation, unwrapSingleConstructors: false})
};
const asParamDineInLocation = {
  fromParam: /* #__PURE__ */ Restaumatic$dRouteAsURL.fromParamJSON(decodeDineInLocation),
  toParam: /* #__PURE__ */ Restaumatic$dRouteAsURL.toParamJSON(encodeDineInLocation)
};
export {
  $DineInLocation,
  ServingLocation,
  ServingLocationIsSymbol,
  Table,
  TableIsSymbol,
  areaIdIsSymbol,
  areaNameIsSymbol,
  asParamDineInLocation,
  decodeDineInLocation,
  decodeWithOptionsOther,
  encodeDineInLocation,
  encodeWithOptionsOther,
  encodingOptsDineInLocation,
  eqDineInLocation,
  genericDineInLocation,
  numberIsSymbol,
  pointNameIsSymbol,
  showDineInLocation,
  toFillFormTypeDineInLocat,
  unscrambleDecodeDineInLocation
};
